import AssignedVisitList from "../components/AssignedVisitList";

function AssignedVisitListPage() {
  return <AssignedVisitList />;
}

export default AssignedVisitListPage;
